import React from 'react'
import { Header } from 'components/Header'
import { Button, Flex } from '@workwhile/ui'
import { QueryStatus } from 'components/QueryStatus'
import { useWhoamiContextValue } from 'components/Whoami/WhoamiProvider'
import { useChargesContextValue } from '../context/ChargesProvider'
import { useChargesWorkflowsContextValue } from '../context/ChargesWorkflowsProvider'

export const ChargesHeader = () => {
  const { state, actions } = useChargesContextValue()
  const { generateInvoiceFlow } = useChargesWorkflowsContextValue()
  const { hasPermission } = useWhoamiContextValue()
  const canGenerateInvoice = hasPermission('finance_specialist')

  return (
    <Header
      title="Charges"
      rightContent={
        <Flex alignItems="center" gap={2}>
          {state.hasIdentityFilter ? (
            <QueryStatus
              dataUpdatedAt={state.dataUpdatedAt}
              isFetching={state.isFetching}
              refetch={actions.refetch}
              isError={state.isError}
              error={state.error}
            />
          ) : null}
          {canGenerateInvoice ? (
            <Button
              variant="primary"
              kind="medium"
              onClick={generateInvoiceFlow.open}
            >
              Generate invoice
            </Button>
          ) : null}
        </Flex>
      }
    />
  )
}
